import { SelectButton } from 'components/BikeSummaryItem/BikeSummaryItem.styled';
import { minBp } from 'src/lib/theme';
import styled from 'styled-components';

export const Wrap = styled.div`
  ${({ mobileOnly, desktopOnly }) => `
    padding: 0;
    height: 100%;
    display: ${desktopOnly ? 'none' : 'block'};

    @media ${minBp('desktop')} {
      padding: 65px 40px 0 40px;
      height: 100%;
      display: ${mobileOnly ? 'none' : 'block'};
    }
  `}
`;

export const BikeTitle = styled.h3`
  margin: 0 0 12px;
  text-transform: uppercase;
  line-height: 1.25;
  font-size: 20px;

  @media ${minBp('desktop')} {
    font-size: 25px;
    margin: 0 0 25px;
  }
`;

export const TotalTitle = styled.div`
  display: block;
  color: #2a2a2a;
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 4px;

  @media ${minBp('tabletLarge')} {
    font-size: 14px;
  }
`;

export const TotalWrap = styled.div`
  ${({ theme }) => `
    border-bottom: 1px solid ${theme.colors.hairline};
    margin-bottom: 24px;
    padding-bottom: 18px;
  `}
`;

export const Total = styled.span`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    color: #000;
    font-size: 26px;
    font-family: ${theme.fonts.dinDemi};
    line-height: 33px;

    @media ${minBp('tabletLarge')} {
      font-size: 30px;
    }
  `}
`;

export const InfoCircleWrap = styled.button`
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  vertical-align: middle;
  padding: 0;
  margin-left: 3px;

  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    position: relative;
    top: 2px;
  }

  svg {
    height: 16px;
    width: 16px;
    padding-bottom: 2px;

    @media ${minBp('tabletLarge')} {
      height: 20px;
      width: 18px;
    }

    path {
      fill: #2a2a2a;
    }
  }
`;

export const CalculateFinanceButton = styled.button`
  ${({ theme }) => `
    appearance: none;
    background: transparent;
    border: 0;
    margin-top: 10px;
    padding: 0;
    font-size: 15px;
    font-family: ${theme.fonts.dinDemi};
    text-transform: uppercase;

    svg {
      width: 16px;
      height: 22px;
      vertical-align: middle;
      margin-right: 8px;
      position: relative;
      bottom: 1px;

      path {
        fill: black;
      }
    }

    .icon--arrow-right {
      margin-left: 4px;
      position: relative;
      top: 1px;
    }
  `}
`;

export const Extras = styled.div``;

export const ExtrasTitle = styled.h4`
  font-size: 16px;
  margin-bottom: 24px;
  text-transform: uppercase;
`;

export const Extra = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 16px;

  &:not(:last-of-type) {
    margin-bottom: 25px;
  }

  @media ${minBp('desktop')} {
    justify-content: space-between;
  }
`;

export const ExtraIconWrap = styled.div`
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 45px;
  min-height: 50px;

  @media ${minBp('desktop')} {
    min-width: 64px;
  }
`;

export const ExtraIcon = styled.img`
  width: 30px;
  height: 30px;
`;

export const ExtraDetails = styled.div`
  display: flex;
  flex-direction: column;

  @media ${minBp('desktop')} {
    align-items: center;
    flex-direction: row;
    flex: 1;
  }
`;

export const ExtraName = styled.span`
  ${({ theme }) => `
    color: ${theme.colors.heading};
    font-family: ${theme.fonts.dinDemi};
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 2px;
    text-transform: uppercase;

    @media ${minBp('desktop')} {
      flex: 1;
      margin-bottom: 0;
    }
  `}
`;

export const ExtraPrice = styled.span`
  font-size: 14px;
  line-height: 20px;

  @media ${minBp('desktop')} {
    border-left: 1px solid #c9c9c9;
    line-height: 32px;
    margin-left: 14px;
    padding-right: 14px;
    padding-left: 14px;
    min-width: 75px;
  }
`;

export const ExtraCTA = styled(SelectButton)`
  margin-left: auto;

  &:disabled {
    background-color: gray;
    border-color: gray;
    cursor: not-allowed;
  }
`;

export const AdditionalCTAWrap = styled.div`
  ${({ theme }) => `
    margin: 25px 0 30px;

    @media ${minBp('tablet')} {
      display: flex;
      justify-content: center;
      margin: 35px 0;
    }
  `}
`;

export const AdditionalCTA = styled.a`
  ${({ theme, primary }) => `
    background: ${
      primary ? theme.colors.buttons.primary : theme.colors.buttons.default
    };
    color: #fff;
    height: 59px;
    width: 100%;
    text-transform: uppercase;
    font-size: 17px;
    font-family: ${theme.fonts.dinDemi};
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    padding-top: 3px;
    cursor: pointer;
    appearance: none;
    border: 0;

    &:focus {
      outline-offset: -0.125rem;
    }

    &:hover, &:focus {
      background: ${primary ? '#8F111F' : '#505050'};
    }

    &:not(:last-child) {
      margin-bottom: 16px;
    }

    @media ${minBp('tablet')} {
      min-width: 189px;

      &:not(:last-child) {
        margin-bottom: 0;
      }

      &:first-child {
        margin-right: 7px;
      }

      &:last-child {
        margin-left: 7px;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  `}
`;

export const Actions = styled.div`
  padding-bottom: 35px;

  @media ${minBp('desktop')} {
    padding-bottom: 65px;
  }
`;

export const Action = styled.a`
  ${({ theme }) => `
    display: flex;
    flex-direction: row;
    align-items: center;
    background: transparent;
    font-family: ${theme.fonts.dinRegular};
    font-size: 16px;
    text-decoration: none;
    color: #2a2a2a;
    height: 28px;
    cursor: pointer;
    border: 0;
    position: relative;
    padding: 0;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    &:disabled {
      opacity: 0.5;
    }

    svg {
      position: absolute;
      right: 30px;

      @media ${minBp('desktop')} {
        position: static;
      }

      path, g {
        fill: #000;
      }
    }
  `}
`;

export const ActionIcon = styled.img`
  padding: 4px;
  height: 34px;
  width: 34px;
`;

export const ActionLabelWrap = styled.span`
  font-family: ${({ theme }) => theme.fonts.dinRegular};
  display: block;
  margin-left: 20px;
  font-size: 16px;

  @media ${minBp('tabletLarge')} {
    font-size: 18px;
  }
`;

export const PopupLabel = styled.div`
  a {
    color: black;
  }
`;
